<template>
    <div>
        <b-alert v-if="summary" show :variant="summary.variant" class="mt-3 mb-0">
            <strong>{{ summary.title }}</strong>
            <div v-for="(l, i) in summary.lines" :key="i">{{ l }}</div>
        </b-alert>

        <b-list-group class="mt-3" v-if="steps.length">
            <b-list-group-item v-for="(s, i) in steps" :key="s.key">
                <div class="d-flex align-items-center">
                    <b-badge :variant="statusVariant(s.state)" class="mr-2">{{ s.state }}</b-badge>
                    <strong>{{ s.label }}</strong>
                    <b-spinner v-if="s.state === 'running'" small class="ml-2" />
                    <b-button
                        v-if="!running && retryable && i > 0 && (s.state === 'failed' || s.state === 'warning')"
                        size="sm"
                        variant="outline-primary"
                        class="ml-auto"
                        @click="$emit('retry', i)"
                        >Retry this step</b-button
                    >
                </div>
                <div v-if="s.lines.length" class="mt-2 small">
                    <div v-for="(l, j) in s.lines" :key="j">{{ l }}</div>
                </div>
                <pre v-if="s.log" class="small mt-2 mb-0 bg-light p-2">{{ s.log }}</pre>
                <b-alert
                    v-if="s.help.length"
                    show
                    :variant="s.state === 'failed' ? 'danger' : 'warning'"
                    class="mt-2 mb-0 small"
                >
                    <strong>What to do</strong>
                    <ul class="mb-0 pl-3">
                        <li v-for="(h, j) in s.help" :key="j">{{ h }}</li>
                    </ul>
                </b-alert>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
// Progress / result list used by the HKTVmall manual upload page.
// steps: [{ key, label, state: waiting|running|done|warning|failed, lines: [], log: "", help: [] }]
export default {
    name: "HktvmallStepList",
    props: {
        steps: { type: Array, default: () => [] },
        summary: { type: Object, default: null },
        running: { type: Boolean, default: false },
        retryable: { type: Boolean, default: false }
    },
    methods: {
        statusVariant(state) {
            return { waiting: "secondary", running: "primary", done: "success", warning: "warning", failed: "danger" }[
                state
            ];
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/HktvmallStepList.vue